import React from 'react';
import { Lightbulb } from '@phosphor-icons/react';

/**
 * PageWhy — one-line "what is this page for?" explainer.
 *
 * Place directly under every feature-page title. Outcome-focused, plain-English.
 * Reassures curious users and reduces the "what am I supposed to do here?" friction.
 *
 * Usage:
 *   <PageWhy>Dial in the exact product amount for each zone so you don't over-apply.</PageWhy>
 */
export const PageWhy = ({ children, testId = 'page-why' }) => (
  <p
    className="text-sm text-muted-foreground leading-relaxed flex items-start gap-2 max-w-2xl"
    data-testid={testId}
  >
    <Lightbulb size={15} weight="fill" className="text-primary shrink-0 mt-[3px]" />
    <span>{children}</span>
  </p>
);

export default PageWhy;
